var map = {
	"./cs": [
		"./src/locales/cs.json",
		"lang-cs"
	],
	"./cs-CZ": [
		"./src/locales/cs-CZ.json",
		"lang-cs-CZ"
	],
	"./cs-CZ.json": [
		"./src/locales/cs-CZ.json",
		"lang-cs-CZ"
	],
	"./cs.json": [
		"./src/locales/cs.json",
		"lang-cs"
	],
	"./de": [
		"./src/locales/de.json",
		"lang-de"
	],
	"./de-DE": [
		"./src/locales/de-DE.json",
		"lang-de-DE"
	],
	"./de-DE.json": [
		"./src/locales/de-DE.json",
		"lang-de-DE"
	],
	"./de.json": [
		"./src/locales/de.json",
		"lang-de"
	],
	"./en": [
		"./src/locales/en.json",
		"lang-en"
	],
	"./en-GB": [
		"./src/locales/en-GB.json",
		"lang-en-GB"
	],
	"./en-GB.json": [
		"./src/locales/en-GB.json",
		"lang-en-GB"
	],
	"./en-IE": [
		"./src/locales/en-IE.json",
		"lang-en-IE"
	],
	"./en-IE.json": [
		"./src/locales/en-IE.json",
		"lang-en-IE"
	],
	"./en-US": [
		"./src/locales/en-US.json"
	],
	"./en-US.json": [
		"./src/locales/en-US.json"
	],
	"./en.json": [
		"./src/locales/en.json",
		"lang-en"
	],
	"./es": [
		"./src/locales/es.json",
		"lang-es"
	],
	"./es-CL": [
		"./src/locales/es-CL.json",
		"lang-es-CL"
	],
	"./es-CL.json": [
		"./src/locales/es-CL.json",
		"lang-es-CL"
	],
	"./es-ES": [
		"./src/locales/es-ES.json",
		"lang-es-ES"
	],
	"./es-ES.json": [
		"./src/locales/es-ES.json",
		"lang-es-ES"
	],
	"./es.json": [
		"./src/locales/es.json",
		"lang-es"
	],
	"./fr": [
		"./src/locales/fr.json",
		"lang-fr"
	],
	"./fr-BE": [
		"./src/locales/fr-BE.json",
		"lang-fr-BE"
	],
	"./fr-BE.json": [
		"./src/locales/fr-BE.json",
		"lang-fr-BE"
	],
	"./fr-FR": [
		"./src/locales/fr-FR.json",
		"lang-fr-FR"
	],
	"./fr-FR.json": [
		"./src/locales/fr-FR.json",
		"lang-fr-FR"
	],
	"./fr.json": [
		"./src/locales/fr.json",
		"lang-fr"
	],
	"./hu": [
		"./src/locales/hu.json",
		"lang-hu"
	],
	"./hu-HU": [
		"./src/locales/hu-HU.json",
		"lang-hu-HU"
	],
	"./hu-HU.json": [
		"./src/locales/hu-HU.json",
		"lang-hu-HU"
	],
	"./hu.json": [
		"./src/locales/hu.json",
		"lang-hu"
	],
	"./nl": [
		"./src/locales/nl.json",
		"lang-nl"
	],
	"./nl-BE": [
		"./src/locales/nl-BE.json",
		"lang-nl-BE"
	],
	"./nl-BE.json": [
		"./src/locales/nl-BE.json",
		"lang-nl-BE"
	],
	"./nl-NL": [
		"./src/locales/nl-NL.json",
		"lang-nl-NL"
	],
	"./nl-NL.json": [
		"./src/locales/nl-NL.json",
		"lang-nl-NL"
	],
	"./nl.json": [
		"./src/locales/nl.json",
		"lang-nl"
	],
	"./pl": [
		"./src/locales/pl.json",
		"lang-pl"
	],
	"./pl-PL": [
		"./src/locales/pl-PL.json",
		"lang-pl-PL"
	],
	"./pl-PL.json": [
		"./src/locales/pl-PL.json",
		"lang-pl-PL"
	],
	"./pl.json": [
		"./src/locales/pl.json",
		"lang-pl"
	],
	"./pt": [
		"./src/locales/pt.json",
		"lang-pt"
	],
	"./pt-PT": [
		"./src/locales/pt-PT.json",
		"lang-pt-PT"
	],
	"./pt-PT.json": [
		"./src/locales/pt-PT.json",
		"lang-pt-PT"
	],
	"./pt.json": [
		"./src/locales/pt.json",
		"lang-pt"
	],
	"./sk": [
		"./src/locales/sk.json",
		"lang-sk"
	],
	"./sk-SK": [
		"./src/locales/sk-SK.json",
		"lang-sk-SK"
	],
	"./sk-SK.json": [
		"./src/locales/sk-SK.json",
		"lang-sk-SK"
	],
	"./sk.json": [
		"./src/locales/sk.json",
		"lang-sk"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;